import { User } from "oidc-client-ts";

const authenticationSettings = {
  authenticationEnabled: process.env.REACT_APP_USE_AUTHENTICATION === "true",
  oidcConfig: {
    authority: process.env.REACT_APP_AUTH_URL,
    client_id: process.env.REACT_APP_AUTH_IDENTITY_CLIENT_ID,
    redirect_uri: process.env.REACT_APP_AUTH_REDIRECT_URL,
    scope: "openid profile email",
    audience: process.env.REACT_APP_AUTH_AUDIENCE,
    onSigninCallback: (_user: User | void): void => {
      window.history.replaceState({}, document.title, window.location.pathname);
    },
  },
};
export default authenticationSettings;
